import { SetURLSearchParams } from 'react-router-dom';
import { Filter } from 'src/utils/composeFilter';
import {
    ORDER_BY_NUMBER_QUERY_PARAM,
    ORDER_BY_STRING_QUERY_PARAM,
} from 'src/modules/common/constants';

export const applyFilterToURlSearchParams = (filter: Filter, searchParams: URLSearchParams): URLSearchParams => {
    const newSearch = new URLSearchParams();
    Object.entries(filter).forEach(([name, value]) => {
        if (value.length > 0) {
            newSearch.set(name, JSON.stringify(value));
        }
    });
    newSearch.delete(ORDER_BY_NUMBER_QUERY_PARAM);
    newSearch.delete(ORDER_BY_STRING_QUERY_PARAM);

    const input = searchParams.get('input');
    const kind = searchParams.get('kind');
    if (input) {
        newSearch.set('input', input);
    }

    if (kind) {
        newSearch.set('kind', kind);
    }

    return newSearch;
};

export const createUpdateUrlAndState = (
    setSearchParams: SetURLSearchParams,
    searchParams: URLSearchParams,
) => (newFilter: Filter) => {
    const newSearch = applyFilterToURlSearchParams(newFilter, searchParams);
    setSearchParams(newSearch, { replace: true });
};
